export default __webpack_public_path__ + "static/media/socialMedia.d3cf638f.png";